import styled from '@emotion/styled/macro'
import copy from 'copy-to-clipboard'
import useHover from 'hooks/useHover'
import { ifProp } from 'mixins'
import { IconButton } from 'office-ui-fabric-react'
import * as React from 'react'

const Container = styled.div`
  position: relative;
  display: ${ifProp({ stretch: true }, 'block', 'inline-block')};
  padding-right: ${ifProp({ stretch: true }, '0', '32')}px;
`
const CopyIconButton = styled(IconButton)`
  position: absolute !important;
  right: -1px;
  top: 50%;
  margin-top: -16px;
`

export interface CopyToClipboardProps {
  children?: any
  stretch?: boolean
}

export const CopyToClipboard: React.FunctionComponent<CopyToClipboardProps> = ({
  children,
  stretch,
}) => {
  const [hoverRef, isHovered] = useHover()

  const copyToClipboard = isHovered
    ? (ev: React.MouseEvent<any>) => {
        if (hoverRef.current) {
          const text = (hoverRef.current.textContent || '')
            .replace(
              String.fromCharCode(59592), // copy icon
              ''
            )
            .trim()

          copy(text, {
            debug: process.env.NODE_ENV !== 'production',
          })
        }
        ev.preventDefault()
        ev.stopPropagation()
        return false
      }
    : null

  return (
    <Container ref={hoverRef} stretch={!!stretch}>
      {children}
      {isHovered && (
        <CopyIconButton
          data-selection-disabled={true}
          iconProps={{ iconName: 'Copy' }}
          onClick={copyToClipboard!}
        />
      )}
    </Container>
  )
}
